module.exports = __webpack_public_path__ + "img/header-engagementRingsFastDelivery@2x.6d6fbe5.webp";